module.exports = __webpack_public_path__ + "ev-hamburger.svg?96e7dda477dae38289f816a163630502";